import React from 'react';
import AdminRouteGuard from '../../components/guards/AdminRouteGuard';
import AdminManagementPage from './AdminManagementPage';

const AdminManagementPageWrapper: React.FC = () => {
  return (
    <AdminRouteGuard>
      <AdminManagementPage />
    </AdminRouteGuard>
  );
};

export default AdminManagementPageWrapper;